// import moment from "moment";

export const monthDiff = function (d1, d2) {
    const diffTime = Math.abs(d2 - d1);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return (diffDays / 30).toFixed(1);
}

export const calculateApprovedAmountWeekly = (salary_multiplier, avg_salary, amount_requested) => {
    // Average salary * salary multiplier. Max amount limited to 20K
    //console.log(amount_requested)
    salary_multiplier = Number(salary_multiplier)
    avg_salary = Number(avg_salary) > 0 ? Number(avg_salary) : 0;
    let result = Math.round(avg_salary * salary_multiplier) < amount_requested ? Math.round(avg_salary * salary_multiplier) : amount_requested;
    console.log("calculating weekly approved amount", avg_salary, salary_multiplier, result <= 20000 ? result : 20000)
    return result <= 20000 ? result : 20000;
}

export const calculateSalaryMultiplierWeekly = (experience) => {
    experience = Number(experience);
    let salary_multiplier = 0
    if (experience <= 0.75) {
        salary_multiplier = 0
    }
    else if (experience > 0.75 && experience <= 1) {
        salary_multiplier = 3
    }
    else if (experience > 1 && experience <= 1.5) {
        salary_multiplier = 4
    }
    else if (experience > 1.5 && experience <= 2) {
        salary_multiplier = 5
    }
    else if (experience > 2 && experience <= 2.5) {
        salary_multiplier = 6
    }

    else if (experience > 2.5 && experience <= 3) {
        salary_multiplier = 7
    }
    else if (experience > 3) {
        salary_multiplier = 8
    }
    console.log("calculating weekly salary multiplier", salary_multiplier)
    return salary_multiplier

}